import { isLeft } from "fp-ts/lib/Either";
import { DATETIME_DISPLAY_FORMATS, Store } from "@inferno/renderer-shared-core";
import { formatImage, placeholderImage } from "@ihr-radioedit/inferno-core";
import * as Webapi from "@ihr-radioedit/inferno-webapi";
import { getPaths } from "@ihr-radioedit/inferno-core";
import { ILog } from "@ihr-radioedit/inferno-core";
import { Heading } from "../../../../core/ui/Heading.component";
import "./CoastShowFrontMatter.style.scss";
import { CoastShowItemDetailsButton } from "../../components/CoastShowItemDetailsButton.component";
import { CoastLinkedHost } from "../../components/CoastLinkedHost.component";
import { ResponsiveImage } from "../../../../core/components/ResponsiveImage.component";
import { RESPONSIVE_IMAGE } from "@inferno/renderer-shared-core";
import { zonedTimeFormat } from "@inferno/renderer-shared-core";
import { generateImageAssetSizes } from "@inferno/renderer-shared-core";
import { inject } from "mobx-react";
import { CoastShowPayloadResolver } from "./CoastContent.types";
import { Block_SitesItemBlock_Fragment } from "@ihr-radioedit/inferno-webapi";
import { CoastLinkedGuests } from "../../components/CoastLinkedGuests.component";

const log = ILog.logger("FrontMatter");

interface CoastShowFrontMatterProps {
  content: Webapi.PublishRecordFragment;
  store?: Store;
  block: Block_SitesItemBlock_Fragment;
}

export const CoastShowFrontMatter = inject("store")(({ content, store }: CoastShowFrontMatterProps) => {
  if (!store) {
    return null;
  }
  const resolvedPayload = CoastShowPayloadResolver.decode(content.payload);

  if (isLeft(resolvedPayload)) {
    log.error(`Payload failed validation: ${getPaths(resolvedPayload)}`);
    return null;
  }

  const { summary, fields } = resolvedPayload.right;
  const { env } = store;

  const { srcset, sizes } = generateImageAssetSizes(formatImage(summary.image.url, env.IMAGE_HOST));
  const placeholderSrc = `${placeholderImage}?ops=resize(900,506),quality(10)`;

  const timezone = store.site.index.timeZone || env.DEFAULT_TIMEZONE;

  const formattedShowDate =
    fields.show_date?.value &&
    zonedTimeFormat({
      date: fields.show_date.value,
      timezone,
      outputFormat: DATETIME_DISPLAY_FORMATS.FULL_DAY_FULL_MONTH_FULL_YEAR,
    });

  return (
    <div className="show-summary">
      <section className="show-details">
        <Heading level={2}>{content.summary.title}</Heading>
        <figcaption>
          <CoastShowItemDetailsButton content={content} />
          <CoastLinkedHost titleOnSameLine={false} item={content} />
          <CoastLinkedGuests titleOnSameLine={true} item={content} guestImage={false} />
          {formattedShowDate ? (
            <p>
              <time className="thumb-meta-value">{formattedShowDate}</time>
            </p>
          ) : null}
        </figcaption>
      </section>
      <figure className="item-thumb">
        <ResponsiveImage
          alt={summary.image.alt_text || summary.title || ""}
          src={placeholderSrc}
          placeholder={placeholderSrc}
          srcset={srcset}
          sizes={sizes}
          initialWidth={RESPONSIVE_IMAGE.responsiveImageInitialWidth}
          initialHeight={RESPONSIVE_IMAGE.responsiveImageInitialHeight}
        />
      </figure>
    </div>
  );
});

export default CoastShowFrontMatter;
